export function getBrowserTimeZone() {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone || "UTC";
  } catch {
    return "UTC";
  }
}

const pad2 = (value) => String(value).padStart(2, "0");

export function isValidTimeZone(timeZone) {
  if (!String(timeZone || "").trim()) return false;

  try {
    new Intl.DateTimeFormat("en-US", { timeZone: String(timeZone).trim() }).format(new Date());
    return true;
  } catch {
    return false;
  }
}

export function normalizeTimeZone(timeZone, fallback = getBrowserTimeZone()) {
  const candidate = String(timeZone || "").trim();
  if (isValidTimeZone(candidate)) return candidate;
  return isValidTimeZone(fallback) ? fallback : "UTC";
}

export function getDatePartsInTimeZone(timeZone, now = new Date()) {
  const formatter = new Intl.DateTimeFormat("en-CA", {
    timeZone: normalizeTimeZone(timeZone, "UTC"),
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    weekday: "short",
  });

  const parts = formatter.formatToParts(now);
  const map = Object.fromEntries(parts.map((part) => [part.type, part.value]));
  const year = Number(map.year || now.getUTCFullYear());
  const month = Number(map.month || now.getUTCMonth() + 1);
  const day = Number(map.day || now.getUTCDate());
  const weekday = String(map.weekday || "Mon");

  return {
    year,
    month,
    day,
    weekday,
    date: `${year}-${pad2(month)}-${pad2(day)}`,
  };
}

function isoWeekNumber(year, month, day) {
  const date = new Date(Date.UTC(year, month - 1, day));
  date.setUTCDate(date.getUTCDate() + 4 - (date.getUTCDay() || 7));
  const yearStart = new Date(Date.UTC(date.getUTCFullYear(), 0, 1));
  return Math.ceil(((date.getTime() - yearStart.getTime()) / 86400000 + 1) / 7);
}

export function getWeekIdForTimeZone(timeZone, now = new Date()) {
  const parts = getDatePartsInTimeZone(timeZone, now);
  return `${parts.year}-${pad2(isoWeekNumber(parts.year, parts.month, parts.day))}`;
}
